<!-- 医院信息管理 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <hospitalListAction v-if="showStatus" ref="hospitalListAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></hospitalListAction>
        </el-drawer>
        <div class="page_content_top">
            <div class="page_content_top_line">
                <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            </div>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="['lomApptype']" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-radio-group v-if="formOneValue.entityField == 'lomApptype'" v-model="getRequestData[formOneValue.entityField]" @change="searchData">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button v-for="(typeValue, typeKey) in $store.state.lomApptype" :key="typeKey" :label="typeValue.id">
                                {{ typeValue.name }}
                            </el-radio-button>
                        </el-radio-group>
                    </template>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <div v-if="tableValye.entityField == 'lomApptype'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.lomApptype) }}
                            </div>
                            <!-- 申请时间 -->
                            <span v-else-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                            </span>
                            <!-- 创建时间 -->
                            <span v-else-if="tableValye.entityField == 'createTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <!-- 状态判断 -->
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'lomState'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.lomState) }}</el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog title="授权" :visible.sync="authorizationShow" width="1000px" append-to-body>
            <div style="display: flex;align-items: center;">
                <div class="left">
                    <el-button type="primary" @click="add(938101838391,'tcmName')">新增</el-button>
                    <el-button type="danger" @click="del('tcmName')">删除</el-button>
                    <el-table size="mini" stripe ref="authorizationTable" :data="authorizationList" height="300" border style="width: 100%" highlight-current-row>
                        <el-table-column label="选择操作" width="80">
                            <template slot-scope="scope">
                                <el-radio v-model="authorizationIndex" :label="scope.$index" border size="mini">
                                    <i class="el-icon-thumb"></i>
                                </el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="80" prop="tcmId" label="终端客户ID"></el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="100" prop="tcmName" label="终端客户"></el-table-column>
                    </el-table>
                </div>
                <div class="right" v-if="authorizationList.length>0">
                    <el-button type="primary" @click="add(8820873997127717,'bgiBrand')">新增</el-button>
                    <el-button type="danger" @click="del('bgiBrand')">删除</el-button>
                    <el-table size="mini" stripe ref="brandTable" :data="authorizationList[authorizationIndex].brandList" height="300" border style="width: 100%" highlight-current-row @current-change="handleBrandSelect">
                        <el-table-column label="选择操作" width="80">
                            <template slot-scope="scope">
                                <el-radio v-model="brandIndex" :label="scope.$index" border size="mini">
                                    <i class="el-icon-thumb"></i>
                                </el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="100" prop="bgiBrand" label="品牌"></el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="80" prop="isJc" label="是否集采">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.isJc" placeholder="请选择">
                                    <el-option label="是" :value="1"></el-option>
                                    <el-option label="否" :value="0"></el-option>
                                    <el-option label="全部" :value="2"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="certificate" v-if="authorizationList.length>0 && authorizationList[authorizationIndex].brandList.length>0">
                    <el-button type="primary" @click="baseregistnoQuery">新增</el-button>
                    <el-button type="danger" @click="del('certificateName')">删除</el-button>
                    <el-table size="mini" stripe :data="getCertificateData()" height="300" border style="width: 100%" highlight-current-row>
                        <el-table-column v-if="getCertificateData().length > 0" label="选择操作" width="80">
                            <template slot-scope="scope">
                                <el-radio v-model="baseregistnoIndex" :label="scope.$index" border size="mini">
                                    <i class="el-icon-thumb"></i>
                                </el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="130" prop="bgiRegistname" label="注册证名称"></el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="100" prop="bgiRegistno" label="注册证编号"></el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="100" prop="bgiLineClass" label="产品线"></el-table-column>
                        <el-table-column align="center" show-overflow-tooltip min-width="100" prop="glTervalidity" label="注册有效期">  
                            <template slot-scope="scope">
                                {{ $common.getLocalTime(scope.row.glTervalidity) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onsubmit">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" :top="'10px'">
            <SearchSchemeMultiple  v-if="seId=='8820873997127717'" ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span v-if="seId=='8820873997127717'" slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
            <SearchScheme v-else ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 注册证选择弹窗 -->
        <el-dialog title="选择注册证" :visible.sync="certificateDialogVisible" width="800px" append-to-body>
            <div class="certificate-search">
                <el-input v-model="bgiRegistno" placeholder="请输入注册证编号" clearable @keyup.enter.native="certificateQuery" style="width: 300px; margin-right: 10px;"></el-input>
                <el-button type="primary" @click="certificateQuery">查询</el-button>
            </div>
            <el-table ref="certificateTable" size="mini" stripe :data="baseregistnoVos" height="400" border style="width: 100%" highlight-current-row @selection-change="handleCertificateSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="200" prop="bgiRegistname" label="注册证名称"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="100" prop="bgiRegistno" label="注册证编号"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="100" prop="bgiLineClass" label="产品线"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="100" prop="glTervalidity" label="注册有效期">  
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.glTervalidity) }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="certificate-pagination" style="margin-top: 10px; text-align: right;">
                <v-pagination :page="certificatePage.page" :rows="certificatePage.rows" :total="certificatePage.total" :pageSize="[20, 50, 100, 200]" @setDataPageSize="setCertificatePageSize" @setDataPageNumber="setCertificatePageNumber"></v-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="certificateDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAddCertificate">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import hospitalListAction from "@/components/hospitalListAction.vue";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { hospitalListAction },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            showStatus: false,
            actionData: {},
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: [],
            DialogVisible: false,
            seId: "",
            seType: "",
            parentSearchData: {},
            //---------授权
            authorizationShow: false,
            authorizationList: [],
            authorizationIndex: 0,
            brandIndex: -1,
            baseregistnoVos: [],
            baseregistnoIndex: -1,
            certificateDialogVisible: false,
            selectedCertificates: [],
            bgiRegistno: "",
            certificatePage: {
                page: 1,
                rows: 20,
                total: 0
            }
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        add(sId, seType) {
            this.seId = sId;
            this.seType = seType
            this.DialogVisible = true;
        },
        del(val) {
            if (val == 'tcmName') {
                this.authorizationList.splice(this.authorizationIndex, 1)
            } else if (val == 'bgiBrand') {
                this.authorizationList[this.authorizationIndex].brandList.splice(this.brandIndex, 1)
            } else if (val == 'certificateName') {
                this.authorizationList[this.authorizationIndex].brandList[this.brandIndex].baseregistnoVos.splice(this.baseregistnoIndex, 1)
            }
        },
        async onsubmit() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            const params = {
                hospitalId: dataInfo.id,
                companyBrandList: this.authorizationList.map(item => {
                    return {
                        companyId: item.tcmId,
                        brandIds: item.brandList.map(item1 => {
                            return {
                                brandId: item1.brandId,
                                isJc: item1.isJc,
                                regIdList: item1.baseregistnoVos ? item1.baseregistnoVos.map(item2 => item2.regId) : []
                            }
                        })
                    }
                })
            }
            const res = await this.$http.dempHospitaladdBrandAuth(params)
            if (res.status == 200) {
                this.authorizationShow = false
                this.authorizationList = []
                this.authorizationIndex = 0
                this.brandIndex = 0
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                console.log(this.authorizationList);

                this.DialogVisible = false; //关闭商品检索窗口
                if (this.seType == 'tcmName') {
                    if (this.authorizationList.filter(item => item.tcmId == val.tcmId).length == 0) {
                        this.authorizationList.push({
                            ...val,
                            brandList: []
                        })
                        this.authorizationIndex = this.authorizationList.length - 1
                    } else {
                        this.$message.error('已存在终端客户')
                    }
                } else if (this.seType == 'bgiBrand') {
                    if (this.authorizationList[this.authorizationIndex].brandList.filter(item => item.brandId == val.brandId).length == 0) {
                        this.authorizationList[this.authorizationIndex].brandList.push({
                            ...val,
                            isJc: 0,
                            baseregistnoVos: []
                        })
                        // 自动选中新添加的品牌行
                        this.brandIndex = this.authorizationList[this.authorizationIndex].brandList.length - 1
                        // 重置注册证索引
                        this.baseregistnoIndex = -1
                    } else {
                        this.$message.error('已存在品牌')
                    }
                }
            }
        },
        getSelect() {
            if (this.seId == '8820873997127717') {
                var mx = this.$refs.searchScheme.multipleSelection
                if (this.authorizationList[this.authorizationIndex].brandList.length == 0) {
                    this.authorizationList[this.authorizationIndex].brandList = mx.map(item => ({
                        ...item,
                        isJc: 0,
                        baseregistnoVos: []
                    }))
                } else {
                    mx.forEach(item => {
                        if (this.authorizationList[this.authorizationIndex].brandList.filter(item1 => item1.brandId == item.brandId).length == 0) {
                            this.authorizationList[this.authorizationIndex].brandList.push({
                                ...item,
                                isJc: 0,
                                baseregistnoVos: []
                            })
                        }
                    })
                }
                // 自动选中最后添加的品牌行
                this.brandIndex = this.authorizationList[this.authorizationIndex].brandList.length - 1
                // 重置注册证索引
                this.baseregistnoIndex = -1
                this.DialogVisible = false
            }
        },
        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seId = sId;
            this.sField = sField
            this.DialogVisible = true;
            this.parentSearchData[type] = this.getRequestData[type]
        },

        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList
                this.getButtonList();
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            console.log(actionData, '动作集合');
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 1:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.lomId,
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.queryData()
                    break;

            }
        },
        async baseregistnoQuery() {
            var dataInfo = this.authorizationList[this.authorizationIndex].brandList[this.brandIndex]
            if (!dataInfo || !dataInfo.manuId) {
                this.$message.warning('请先选择品牌')
                return
            }
            // 重置分页
            this.certificatePage.page = 1
            await this.loadCertificateData(dataInfo.manuId)
        },
         certificateQuery() {
            console.log('查询注册证');
            console.log(this.bgiRegistno, '注册证名称');
            this.certificatePage.page = 1
            this.loadCertificateData()
        },
        // 加载注册证数据（支持分页）
        async loadCertificateData(manuId) {
            let params = {
                page: this.certificatePage.page,
                rows: this.certificatePage.rows,
                bgiRegistno: this.bgiRegistno,
                manuId: manuId || this.authorizationList[this.authorizationIndex].brandList[this.brandIndex].manuId
            }
            const responseData = await this.$http.baseregistnoQuery(params)
            if (responseData.status == 200) {
                this.baseregistnoVos = responseData.result.list || []
                this.certificatePage.total = responseData.result.total || 0
                this.selectedCertificates = []
                this.certificateDialogVisible = true
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 注册证分页 - 切换页码
        setCertificatePageNumber(val) {
            this.certificatePage.page = val
            this.loadCertificateData()
        },
        // 注册证分页 - 切换每页条数
        setCertificatePageSize(val) {
            this.certificatePage.page = 1
            this.certificatePage.rows = val
            this.loadCertificateData()
        },
        // 注册证选择事件
        handleCertificateSelectionChange(selection) {
            this.selectedCertificates = selection
        },
        // 确认添加注册证
        confirmAddCertificate() {
            if (this.selectedCertificates.length === 0) {
                this.$message.warning('请选择要添加的注册证')
                return
            }
            const currentBrand = this.authorizationList[this.authorizationIndex].brandList[this.brandIndex]
            let addedCount = 0
            
            // 处理选中的多个注册证
            this.selectedCertificates.forEach(selectedCert => {
                // 检查是否已存在
                const exists = currentBrand.baseregistnoVos.some(item => 
                    item.bgiRegistno === selectedCert.bgiRegistno && item.glTervalidity === selectedCert.glTervalidity
                )
                
                if (!exists) {
                    // 添加到品牌的 baseregistnoVos 中
                    currentBrand.baseregistnoVos.push({
                        ...selectedCert
                    })
                    addedCount++
                }
            })
            
            if (addedCount > 0) {
                this.$message.success(`成功添加 ${addedCount} 个注册证`)
            } else {
                this.$message.warning('所选注册证已全部存在')
            }
            this.certificateDialogVisible = false
            this.selectedCertificates = []
        },
        // 处理品牌表格行选中事件
        handleBrandSelect(row) {
            if (row) {
                // 找到当前选中行的索引
                const index = this.authorizationList[this.authorizationIndex].brandList.findIndex(item => item === row)
                this.brandIndex = index
                this.baseregistnoIndex = -1
            }
        },
        // 获取注册证数据（根据是否选中品牌决定显示方式）
        getCertificateData() {
            if (!this.authorizationList[this.authorizationIndex] || !this.authorizationList[this.authorizationIndex].brandList) {
                return []
            }
            // 如果没有选中品牌（brandIndex为-1），显示所有品牌的注册证
            if (this.brandIndex === -1) {
                let allCertificates = []
                this.authorizationList[this.authorizationIndex].brandList.forEach(brand => {
                    if (brand.baseregistnoVos && brand.baseregistnoVos.length > 0) {
                        allCertificates = allCertificates.concat(brand.baseregistnoVos)
                    }
                })
                return allCertificates
            }
            // 如果选中了品牌，只显示该品牌的注册证
            const selectedBrand = this.authorizationList[this.authorizationIndex].brandList[this.brandIndex]
            return selectedBrand ? (selectedBrand.baseregistnoVos || []) : []
        },
        async queryData() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            const responseData = await this.$http.dempHospitalqueryBrandAuth({ ids: [dataInfo.id] })
            if (responseData.status == 200) {
                if (responseData.result) {
                    this.authorizationList = responseData.result.companyBrandList
                } else {
                    this.authorizationList = []
                }
                this.authorizationIndex = 0
                this.brandIndex = -1
                this.baseregistnoIndex = -1
            } else {
                this.authorizationList = []
                this.authorizationIndex = 0
                this.brandIndex = -1
                this.baseregistnoIndex = -1
            }
            this.authorizationShow = true
            // 刷新表格视图
            this.$nextTick(() => {
                if (this.$refs.authorizationTable && this.$refs.authorizationTable.doLayout) {
                    this.$refs.authorizationTable.doLayout();
                }
                if (this.$refs.brandTable && this.$refs.brandTable.doLayout) {
                    this.$refs.brandTable.doLayout();
                }
            });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.dempHospitalquery(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.id],
                    };
                    let responseData = await this.$http.dempHospitaldelete(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },


        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
.left {
    flex: 1;
    min-width: 0;
}
.right {
    flex: 1;
    min-width: 0;
    margin-left: 10px;
}
.certificate {
    flex: 1;
    min-width: 0;
    margin-left: 10px;
}
</style>